var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesktopWithPerson = function SvgDesktopWithPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.875 7.875a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 0 0-5.25 0M8 15.75a4.5 4.5 0 1 1 9 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3.5 2.25h18s1.5 0 1.5 1.5v13.5s0 1.5-1.5 1.5h-18s-1.5 0-1.5-1.5V3.75s0-1.5 1.5-1.5M12.5 18.75v3M5 21.75h15"
  })));
};
export default SvgDesktopWithPerson;